import { apiClient, THEME_EDITOR_DATA, THEME_SETTINGS } from '../../../shared/api';

export const fetchThemeEditorData = async () => {
  const response = await apiClient.get(THEME_EDITOR_DATA());

  return response.data;
};

export const updateThemeSettings = async (themeSettings) => {
  const requestBody = {
    theme_settings: themeSettings,
  };

  const response = await apiClient.patch(THEME_SETTINGS(), requestBody);

  return response.data;
};
